import { Navigate } from 'react-router-dom';
import { hasUsableAccessToken } from '../../services/api/apiClient';

export default function ProtectedPortalRoute({ children }) {
  if (!hasUsableAccessToken()) return <Navigate to="/portal/login" replace />;
  return children;
}
